import type { BrandManager } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleBrandManagerQueryResult {
  brandManager: BrandManager
}

export interface SingleBrandManagerQueryVariables {
  id?: GQL_ID
}

const GQL_QUERY_SINGLE_BRAND_MANAGER = gql`
  query (
    $id: ID!
  ) {
    brandManager: singleBrandManager(
      id: $id
    ) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
    }
  }
`

export const useFetchSingleBrandManager = (
  variables: SingleBrandManagerQueryVariables
) =>
  useQuery<SingleBrandManagerQueryResult, SingleBrandManagerQueryVariables>(
    GQL_QUERY_SINGLE_BRAND_MANAGER,
    { variables, skip: !variables.id }
  )
